import $ from "jquery";

class ExternalLinksForArticles {
    constructor() {
        this.init();
    }

    init() {
        const currentElement = $(".custom-icon").find(`[data-social]`),
            currentURL = window.location.href;

        if (!$(".custom-icon")) {
            return;
        }

        $.each(currentElement, function (index, submenu) {
            const socialIcon = $(submenu).data().social;

            if ($(submenu).attr("href") && socialIcon !== "mail") {
                $(submenu).attr("target", "_blank"); // VC does not add this att
                return;
            }

            switch (socialIcon) {
                case "facebook":
                    if ($(submenu).attr("href")) {
                        return;
                    }
                    $(submenu).attr("target", "_blank"); // VC does not add this att
                    $(submenu).attr("href", `https://www.facebook.com/sharer/sharer.php?u=${currentURL}`);
                    break;
                case "twitter":
                    if ($(submenu).attr("href")) {
                        return;
                    }
                    $(submenu).attr("target", "_blank"); // VC does not add this att
                    $(submenu).attr("href", `https://twitter.com/intent/tweet?url=${currentURL}>`)
                    break;
                case "link":
                    function copyOnClick() {
                        const $temp = $("<input>");
                        const $url = $(location).attr('href');

                        $("body").append($temp);
                        $temp.val($url).select();
                        document.execCommand("copy");
                        $temp.remove();

                        $(".clf2020-social-icons").append("<div style='position:absolute;'><h6 class='url-copied-message' style='display:block;padding-top:28px;'>URL copied!</h6></div>")
                        setTimeout(function () {
                            $(".url-copied-message").remove();
                        }, 1500);
                    }
                    $(submenu).attr("tabindex", "0"); // VC does not add this att
                    $(submenu).removeAttr("target");
                    $(submenu).removeAttr("href");
                    $(submenu).click(() => {
                        copyOnClick();
                    });
                    $(submenu).keydown(function (event) {
                        if (event.keyCode === 13) {
                            copyOnClick();
                        }
                    });
                    break;
                case "mail":
                    $(submenu).removeAttr("href");
                    const emailToSent = $(submenu).data().email,
                        subject = "Clara Lionel Foundation",
                        mailTo = `mailto:${emailToSent}?subject=${subject}&body=${currentURL}`;

                    $(submenu).removeAttr("href");
                    $(submenu).attr("href", mailTo);
                    break;
                default:
                    $(submenu).attr("target", "_blank"); // VC does not add this att
                    break;
            }
        });
    }
}

export default ExternalLinksForArticles;